import { useState } from 'react'
import Button from '@/components/ui/Button'
import { FormItem, Form } from '@/components/ui/Form'
import PasswordInput from '@/components/shared/PasswordInput'
// import { apiChangePassword } from '@/services/AuthService'
import { useForm, Controller } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import type { ZodType } from 'zod'
import type { CommonProps } from '@/@types/common'
import Input from '@/components/ui/Input'
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Swal from "sweetalert2"; 
import { useAuth } from '@/auth'

const signotp1 = '/portal/sign-in';
interface ChangePasswordFormProps extends CommonProps {
    resetComplete: boolean
    setResetComplete?: (compplete: boolean) => void
    setMessage?: (message: string) => void
}

type ChangePasswordFormSchema = {
    newPassword: string
    confirmPassword: string
}

const validationSchema: ZodType<ChangePasswordFormSchema> = z
    .object({
        newPassword: z.string({ required_error: 'Please enter your password' }),
        confirmPassword: z.string({
            required_error: 'Confirm Password Required',
        }),
    })
    .refine((data) => data.newPassword === data.confirmPassword, {
        message: 'Confirm password does not match the new password',
        path: ['confirmPassword'],
    })

const ChangePasswordForm = (props: ChangePasswordFormProps) => {
    const [isSubmitting, setSubmitting] = useState<boolean>(false)

    const { className, setMessage: propSetMessage, setResetComplete, resetComplete, children } =
        props

    const {
        handleSubmit,
        formState: { errors },
        control,
    } = useForm<ChangePasswordFormSchema>({
        resolver: zodResolver(validationSchema),
    })
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
     const { changepasswordsumbit } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const storedEmail = localStorage.getItem('userEmail')|| sessionStorage.getItem("NewEmail") || "";
        if (storedEmail) {
            setEmail(storedEmail);
        }
    }, []);



     const [sessionId, setSessionId] = useState(sessionStorage.getItem("sessionId") || "");
    
      useEffect(() => {
        if (!sessionId) {
          const newSessionId = `session-${Date.now()}-${Math.floor(Math.random() * 100000)}`;
          setSessionId(newSessionId);
          sessionStorage.setItem("sessionId", newSessionId);
    
      console.log("sessionId",sessionId); 
    
        }
      }, [sessionId]);
    



    const validatePassword = (password: string): string => {
        const passwordRegex = /^(?!.*\d{6,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/;
    
        if (!password) {
            return "Password is required.";
        }
        if (password.length < 8 || password.length > 16) {
            return "Password must be between 8 and 16 characters.";
        }
        if (!/[A-Z]/.test(password)) {
            return "Password must contain at least one uppercase letter.";
        }
        if (!/[a-z]/.test(password)) {
            return "Password must contain at least one lowercase letter.";
        }
        if (!/\d/.test(password)) {
            return "Password must contain at least one number.";
        }
        if (!/[@$!%*?&]/.test(password)) {
            return "Password must contain at least one special character (@$!%*?&).";
        }
        if (/\d{6,}/.test(password)) {
            return "Password should not contain a sequence of 6 or more consecutive digits.";
        }
    
        return ""; // ✅ No error
    };

const logincount= sessionStorage.getItem('logincount');

console.log("logincount",logincount==='null');


    const onSubmit = async (data: ChangePasswordFormSchema) => {
        const passwordError = validatePassword(data.newPassword);
    if (passwordError) {
        setError(passwordError);
        return;
    }

    if (data.newPassword !== data.confirmPassword) {
        setError("Passwords do not match.");
        return;
    }

    setError("");
    setSubmitting(true); //
        const apiToken = import.meta.env.VITE_API_URL_TOKEN;
        const authToken = sessionStorage.getItem('authToken');

        if (!authToken) {
            setError("Authentication token missing. Please try again.");
            return;



        }




const loginurl =
  logincount === 'null'
    ? `${import.meta.env.VITE_API_URL}/forgotpassword/changetemppassword`
    : `${import.meta.env.VITE_API_URL}/forgotpassword/resetpassword`;

try {
  const response = await fetch(loginurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${apiToken}`, 
                    'Token': authToken || "", 
                },
                body: JSON.stringify({ email, newPassword: data.newPassword }),
                credentials: 'include',
            });

            const sessionId = response.headers.get("Token");
            if (sessionId) {
                sessionStorage.setItem("sessionId", sessionId);
            }

            const result = await response.json();

            // if (result.statusCode === 0) {
            //     setMessage("Password reset successfully. Redirecting to login...");
            //     localStorage.removeItem('authToken');
            //     localStorage.removeItem("authToken");
            //     localStorage.removeItem("userEmail");
            //     sessionStorage.removeItem("rememberedPassword");
            //     localStorage.clear()
               
            //    // setTimeout(() => , 100);
            // //    window.location.href = signotp1;
            //    // location.reload(); 
            // } 

            if (result.statusCode === 0) {
                Swal.fire({
                    title: "Password Reset Successful!",
                    text: "Redirecting to login...",
                    icon: "success", // Make sure 'success' is used correctly
                    timer: 4000,  // Auto close after 3 seconds
                    showConfirmButton: false,
                    allowOutsideClick: false // Prevent clicking outside to dismiss
                }).then(() => {
                    // Clear stored credentials
                    localStorage.removeItem("authToken");
                    localStorage.removeItem("userEmail");
                    if (sessionStorage.getItem("rememberedPassword")) {
                        sessionStorage.removeItem("rememberedPassword");
                    }
                    localStorage.clear();
            
                    // Redirect after the alert
                    window.location.href = signotp1; 
                });
            }
            
            
            else {
                setError(result.message || "Failed to reset password.");
            }
        } catch (error) {
            console.error("Error during password reset:", error);
            setError("An error occurred. Please try again.");
        }
    };

    return (
        <div className='w-100'>
            {!resetComplete ? (
                <Form onSubmit={handleSubmit(onSubmit)} className='login-form'  autoComplete='off'>
                    <FormItem label="Username">
                        <Input type="text" value={email} readOnly className='mb-2' placeholder="Enter Username" />
                    </FormItem>
                    <FormItem
                        label="New Password"
                        invalid={Boolean(errors.newPassword)}
                        errorMessage={errors.newPassword?.message}
                    >
                        <Controller
                        
                            name="newPassword"
                            control={control}
                            render={({ field }) => (
                                <PasswordInput
                                   autoComplete="new-password"  // this is key
                                    className='mb-2'
                                    placeholder="New password"
                                    {...field}
                                    onKeyDown={(e) => {
                                        if (e.key === ' ') {
                                        e.preventDefault();
                                        }
                                    }}
                                       onCopy={(e) => e.preventDefault()}
                onCut={(e) => e.preventDefault()}
                onPaste={(e) => e.preventDefault()}
                                    name="newPassword"  // unique name
                                    id="new-password"   // unique id
                                    
                                />
                            )}
                        />
                    </FormItem>
                    <FormItem
                        label="Confirm Password"
                        invalid={Boolean(errors.confirmPassword)}
                        errorMessage={errors.confirmPassword?.message}
                    >
                        <Controller
                            name="confirmPassword"
                            control={control}
                            render={({ field }) => (
                                <PasswordInput
                                    autoComplete="off"
                                    className='mb-2'
                                    placeholder="Confirm Password"
                                    {...field}
                                    onKeyDown={(e) => {
                                        if (e.key === ' ') {
                                            e.preventDefault();
                                        }
                                    }}
                                                        onCopy={(e) => e.preventDefault()}
                onCut={(e) => e.preventDefault()}
                onPaste={(e) => e.preventDefault()}
                                />
                            )}
                        />
                    </FormItem>
                    {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                    {message && <p className="text-green-500 text-sm mt-2">{message}</p>}
                    <Button
                        className='mt-5'
                        block
                        loading={isSubmitting}
                        variant="solid"
                        type="submit"
                    >
                        {isSubmitting ? 'Submiting...' : 'Change Password'}
                    </Button>
                </Form>
            ) : (
                <>{children}</>
            )}
        </div>
    )
}
export default ChangePasswordForm